import { forgotPasswordSubmit } from '../../../actions/userActions';
import Messages from '../Messages';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';
import { Link } from 'react-router';

const ForgotPasswordForm = ({ content, isResettingPassword, forgotPasswordSubmit }) => {
  return (
    <div className="ContactPage">
      <div className="container content">
        <Messages />
        <div className="bg-light-grey">
          <h3>{content.title}</h3>
          <hr className="pull-left" />
          <div className="clearfix" />
          {content.intro ? <p>{content.intro}</p> : ''}

          <Form
            onSubmit={forgotPasswordSubmit}
            render={({ handleSubmit, submitting }) => (
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="control-label" htmlFor="login_email">
                    Email
                  </label>
                  <Field name="email">
                    {({ input }) => (
                      <input
                        {...input}
                        id="login_email"
                        type="text"
                        className="form-control text"
                        disabled={submitting || isResettingPassword}
                      />
                    )}
                  </Field>
                </div>
                <div className="Actions">
                  <button className="btn btn-primary action" type="submit" disabled={submitting || isResettingPassword}>
                    {content.buttonText}
                  </button>
                  <Link to="/login" className="btn btn-link">
                    {content.loginLinkText}
                  </Link>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  content: state.config.content.forgotPassword,
  isResettingPassword: state.auth.isResettingPassword,
});

const mapDispatchToProps = {
  forgotPasswordSubmit,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);
